import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { routes } from 'src/constants/routes';
import {
    removeStorage,
    getStorage,
    getTokenStorageExpired,
} from 'src/utils/local-storage-versioning';
import store from 'src/store/store';
import { setLoggedIn } from 'src/store/slices/user-slice';
import { setSnackbarState } from 'src/store/slices/snackbar-slice';

export const LogoutCallbackPage: FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        const storage = getStorage();
        const { room, academicYear, paymentPlanId, pid, cbl, rebooker } = storage.redirectState;
        const tokenExpired = getTokenStorageExpired();

        if (room && academicYear) {
            if (tokenExpired) {
                dispatch(setSnackbarState({ message: t('session_expired_message') }));
            }
            removeStorage();
            const params = [`roomCode=${room}`, `academicYear=${academicYear}`];

            if (paymentPlanId) params.push(`paymentPlanId=${paymentPlanId}`);
            if (pid) params.push(`pid=${pid}`);
            if (cbl) params.push(`cbl=${cbl}`);
            if (rebooker) params.push(`rebooker=${rebooker}`);

            navigate(`${routes.summary.index}?${params.join('&')}`);
        }
        store.dispatch(setLoggedIn(false));
    }, [navigate]);

    return null;
};
